import { LlmModelName } from 'llm-model-registry';
import { z } from 'zod';

export const HumanTaskToolDocumentPacketGeneratorConfigSchema = z.object({
  // This is the Companion Documents field from the legacy block
  relevantDocuments: z.string().optional(),
  /** This is the Clinical Documents Packet field from the legacy block */
  preGeneratedPacket: z.string().optional(),
});
export type HumanTaskToolDocumentPacketGeneratorConfig = z.infer<
  typeof HumanTaskToolDocumentPacketGeneratorConfigSchema
>;

export const HumanTaskToolClinicalQuestionAssistantConfigSchema = z.object({
  dataContext: z.string().optional(),
  preamble: z.string().optional(),
  outputRequirements: z.string().optional(),
  additionalInstructions: z.string().optional(),
  modelName: z.nativeEnum(LlmModelName).optional(),
});
export type HumanTaskToolClinicalQuestionAssistantConfig = z.infer<
  typeof HumanTaskToolClinicalQuestionAssistantConfigSchema
>;

export enum HumanTaskToolSidekickAutofillMode {
  Standard = 'Standard',
  AiBased = 'AiBased',
}

export const HumanTaskToolAutofillConfigSchema = z.object({
  dataContext: z.string().optional(),
  mode: z.nativeEnum(HumanTaskToolSidekickAutofillMode).optional(),
});
export type HumanTaskToolAutofillConfig = z.infer<typeof HumanTaskToolAutofillConfigSchema>;

export enum HumanTaskTool {
  DocumentPacketGenerator = 'DocumentPacketGenerator',
  ClinicalQuestionAssistant = 'ClinicalQuestionAssistant',
  Autofill = 'Autofill',
}

export const DEFAULT_ENABLED_HUMAN_TASK_TOOLS: HumanTaskTool[] = [];

export const HumanTaskToolsSchema = z
  .object({
    enabledTools: z
      .array(z.nativeEnum(HumanTaskTool))
      .default(DEFAULT_ENABLED_HUMAN_TASK_TOOLS)
      .optional(),
    config: z
      .object({
        documentPacketGenerator: HumanTaskToolDocumentPacketGeneratorConfigSchema.optional(),
        clinicalQuestionAssistant: HumanTaskToolClinicalQuestionAssistantConfigSchema.optional(),
        autofill: HumanTaskToolAutofillConfigSchema.optional(),
      })
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data.enabledTools?.includes(HumanTaskTool.DocumentPacketGenerator)) {
      if (!data.config?.documentPacketGenerator?.relevantDocuments) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Relevant Documents is required',
          path: ['config', 'documentPacketGenerator', 'relevantDocuments'],
        });
      }
    }
  });
export type HumanTaskTools = z.infer<typeof HumanTaskToolsSchema>;
